import Vue from 'vue';
import Vuex from 'vuex';
import steps from './modules/steps';
Vue.use(Vuex);
var store = new Vuex.Store({
    modules: {
        steps: steps
    }
});
export default store;


// WEBPACK FOOTER //
// ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--2-1!./src/store/index.ts